import { useCallback, useEffect } from "react";
import { RoleAssignment, CreateRoleAssignment, UpdateRoleAssignment } from "../types/models/RoleAssignment.d";
import { UpdateEntityRoleAssignment } from "../types/models/RoleAssignment";
import { useGetRoleAssignmentListQuery, useInsertRoleAssignmentMutation, useDeleteRoleAssignmentMutation, } from "../apis/RoleAssignment.api";
import { useDeleteDialog, useDescriptionAlert } from '../../share';
import { useNavigate } from "react-router";
import { t } from "@lingui/core/macro";

export default function useRoleAssignment(page: number, pageSize: number) {

    const navigate = useNavigate()
    const { openDialog, closeDialog } = useDeleteDialog();

    const { openSuccessAlert, openFailAlert } = useDescriptionAlert()

    const [insertRoleAssignmentMutation, { 
        isLoading: insertRoleAssignmentLoading, 
        isSuccess: insertRoleAssignmentIsSuccess,
        isError: insertRoleAssignmentIsError,
        error: insertRoleAssignmentError,
    }] = useInsertRoleAssignmentMutation()
    
    const [deleteRoleAssignmentMutation, { 
        isLoading: deleteRoleAssignmentLoading,
        isSuccess: deleteRoleAssignmentIsSuccess,
        isError: deleteRoleAssignmentIsError,
        error: deleteRoleAssignmentError,
    }] = useDeleteRoleAssignmentMutation()

    const loading =
        insertRoleAssignmentLoading ||
        
        deleteRoleAssignmentLoading ||
        false

    const insertRoleAssignment = useCallback(async (roleAssignment: CreateRoleAssignment, redirectPath: string|undefined) => {
        try {
            const data = await insertRoleAssignmentMutation(roleAssignment).unwrap()
            if (data) {
                if (redirectPath) {
                    if (redirectPath !== '.') {
                        navigate(redirectPath, {relative: 'path'})
                    }
                } else {
                    navigate(`../${data.id}`, {relative: 'path'})
                }
                return data;
            }
        } catch (e) {
            console.log("add error", e)
            openFailAlert(t`Add error: ` + e.toString())
        }
    }, [insertRoleAssignmentMutation, navigate])
    
    useEffect(() => {
        if (insertRoleAssignmentIsSuccess) {
            openSuccessAlert('Role Assignment created')
        } else if (insertRoleAssignmentIsError) {
            console.log("add error", insertRoleAssignmentError)
            openFailAlert(t`Role Assignment add error: ` + insertRoleAssignmentError?.data?.message)
        }
    }, [
        insertRoleAssignmentIsSuccess,
        insertRoleAssignmentIsError,
        insertRoleAssignmentError
    ]);

    

    const deleteRoleAssignment = useCallback((roleAssignment: RoleAssignment, redirectPath: string|undefined) => {
        openDialog(async () => {
            roleAssignment = {
                ...roleAssignment,
            }
            try {
                const { data } = await deleteRoleAssignmentMutation(roleAssignment);
                if (data != null) {
                    if (redirectPath) {
                        navigate(redirectPath, {relative: 'path'})
                    }
                }
            } catch (e) {
                console.log("delete error", e)
                openFailAlert(t`Delete error: ` + e.toString())
            }
            closeDialog()
        });
    }, [deleteRoleAssignmentMutation, closeDialog, openDialog])
    
    useEffect(() => {
        if (deleteRoleAssignmentIsSuccess) {
            openSuccessAlert(t`Role Assignment deleted`)
        } else if (deleteRoleAssignmentIsError) {
            console.log("delete error", deleteRoleAssignmentError)
            openFailAlert(t`Role Assignment delete error: ` + deleteRoleAssignmentError?.data?.message)
        }
    }, [
        deleteRoleAssignmentIsSuccess,
        deleteRoleAssignmentIsError,
        deleteRoleAssignmentError
    ]);

    return {
        loading,
        insertRoleAssignment,
        
        deleteRoleAssignment
    }
}
